var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable prettier/prettier */
import { useEffect, useState } from "react";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import { ContainerForm } from "../../components/ContainerForm";
import { ContainerLayout } from "../../components/ContainerLayout";
import { FixedMenu } from "../../components/FixedMenu";
import { FormButton, FormButtonType } from "../../components/FormButton";
import { CardTaxaCondutor } from "../../components/Habilitacao/CardTaxaCondutor";
import { EmitirTodosBoletos } from "../../components/Habilitacao/EmitirTodosBoletos";
import AppBarHeader from "../../components/Home/AppBarHeader";
import { Loading } from "../../components/Loading";
import { Modal } from "../../components/Modal";
import { NaoEncontrado } from "../../components/NaoEncontrado";
import { SnackbarFeedback } from "../../components/SnackbarFeedback";
import { ViewPdf } from "../../components/ViewPdf";
import { useAuth } from "../../hooks/useAuth";
import { obterDadosCondutor, obterTaxas } from "../../services/habilitacao.service";
import { obterBoleto } from "../../services/veiculos.service";
import { formatDate } from "../../util/formatadores";
import { Colors } from "../../util/theme";
export var EmitirTaxas = function () {
    var userInfo = useAuth().userInfo;
    var _a = useState(), dados = _a[0], setDados = _a[1];
    var _b = useState(), debitos = _b[0], setDebitos = _b[1];
    var _c = useState(), erro = _c[0], setErro = _c[1];
    var _d = useState(true), loadingDadosCondutor = _d[0], setLoadingDadosCondutor = _d[1];
    var _e = useState(true), loadingDebitos = _e[0], setLoadingDebitos = _e[1];
    var _f = useState(false), consultaVazia = _f[0], setConsultaVazia = _f[1];
    var _g = useState([]), selectedIds = _g[0], setSelectedIds = _g[1];
    var _h = useState(false), modalDebts = _h[0], setModalDebts = _h[1];
    var _j = useState(undefined), base64 = _j[0], setBase64 = _j[1];
    var isCnhVencida = function (dataString) {
        // Extrai o ano, mês e dia da string
        var ano = parseInt(dataString.substring(0, 4), 10);
        var mes = parseInt(dataString.substring(4, 6), 10) - 1; // Mês é baseado em zero no objeto Date
        var dia = parseInt(dataString.substring(6, 8), 10);
        // Cria a data fornecida
        var dataFornecida = new Date(ano, mes, dia);
        // Garante que a data de hoje não inclui horas
        var hoje = new Date();
        var dataHoje = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
        if (dataFornecida < dataHoje) {
            return true;
        }
        else {
            return false;
        }
    };
    var handleChangeId = function (id) {
        if ((selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.length) > 0) {
            setSelectedIds(function (prevSelectedIds) {
                if (prevSelectedIds.includes(id)) {
                    return prevSelectedIds.filter(function (selectedId) { return selectedId !== id; });
                }
                else {
                    return __spreadArray(__spreadArray([], prevSelectedIds, true), [id], false);
                }
            });
        }
        else {
            setSelectedIds([id]);
        }
    };
    var getSelectedDebtInfo = function (id) {
        if (debitos) {
            var selectedDebt = debitos.find(function (debito) { return debito.idDebito === id; });
            return selectedDebt;
        }
    };
    var fetchSelectedDebts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setLoadingDebitos(true);
                    setErro(undefined);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, 5, 6]);
                    if (!selectedIds) return [3 /*break*/, 3];
                    payload = {
                        cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                        listaIdDebito: selectedIds.toString(),
                    };
                    return [4 /*yield*/, obterBoleto(payload)];
                case 2:
                    response = _d.sent();
                    setBase64(response.pdf);
                    _d.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4:
                    error_1 = _d.sent();
                    setErro((_c = (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao gerar boleto");
                    return [3 /*break*/, 6];
                case 5:
                    setLoadingDadosCondutor(false);
                    setLoadingDebitos(false);
                    setModalDebts(false);
                    setSelectedIds([]);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var fetchDadosCondutor = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        payload = {
                            cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                        };
                        return [4 /*yield*/, obterDadosCondutor(payload)];
                    case 1:
                        response = _b.sent();
                        setDados(response);
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _b.sent();
                        setErro((_a = error_2.response.data.MensagemRetorno) !== null && _a !== void 0 ? _a : "Erro ao buscar dados do condutor");
                        return [3 /*break*/, 4];
                    case 3:
                        setLoadingDadosCondutor(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var fetchDebitos = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_3;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        payload = {
                            cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                        };
                        return [4 /*yield*/, obterTaxas(payload)];
                    case 1:
                        response = _b.sent();
                        setDebitos(response);
                        return [3 /*break*/, 4];
                    case 2:
                        error_3 = _b.sent();
                        if (error_3.response &&
                            error_3.response.data.MensagemRetorno ===
                                "Não há débitos para a pessoa informada.") {
                            setConsultaVazia(true);
                        }
                        else {
                            setErro((_a = error_3.response.data.MensagemRetorno) !== null && _a !== void 0 ? _a : "Erro ao buscar débitos");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        setLoadingDebitos(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchDadosCondutor();
        fetchDebitos();
    }, [userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username]);
    if (loadingDadosCondutor || loadingDebitos) {
        return (_jsxs(_Fragment, { children: [_jsx(AppBarHeader, { titulo: "D\u00E9bitos do Condutor", voltarPara: "/home" }), _jsx(Loading, {})] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(FixedMenu, { title: "Consulta e Emiss\u00E3o de Taxas da CNH" }), _jsx(Box, __assign({ mt: { xs: "17rem", md: "13rem" } }, { children: _jsxs(ContainerLayout, { children: [_jsxs(Stack, __assign({ flexDirection: "column", alignItems: "start", gap: "1rem", padding: "1rem", boxShadow: 2, sx: { backgroundColor: "white" } }, { children: [_jsx(Typography, __assign({ variant: "body1", fontSize: "1.375rem", fontWeight: "500" }, { children: dados === null || dados === void 0 ? void 0 : dados.nome })), (dados === null || dados === void 0 ? void 0 : dados.dataValidadeCnh) && (_jsx("div", __assign({ style: {
                                        border: "1px solid ".concat(isCnhVencida(dados === null || dados === void 0 ? void 0 : dados.dataValidadeCnh)
                                            ? Colors.VERMELHO_GOV
                                            : Colors.AZUL_GOV),
                                        borderRadius: "2rem",
                                        padding: "0.2rem 0.75rem",
                                        textAlign: "center",
                                    } }, { children: _jsxs(Typography, __assign({ variant: "body2", fontSize: "1rem", sx: {
                                            color: isCnhVencida(dados === null || dados === void 0 ? void 0 : dados.dataValidadeCnh)
                                                ? Colors.VERMELHO_GOV
                                                : Colors.AZUL_GOV
                                        } }, { children: ["Validade: ", formatDate(dados === null || dados === void 0 ? void 0 : dados.dataValidadeCnh)] })) }))), _jsxs(Box, __assign({ display: "flex", justifyContent: "space-between", width: "100%", flexWrap: "wrap" }, { children: [_jsxs("div", { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "N\u00FAmero de Registro:" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: dados === null || dados === void 0 ? void 0 : dados.numeroRegistro }))] }), _jsxs("div", { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "Categoria:" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: dados === null || dados === void 0 ? void 0 : dados.categoriaCnh }))] }), _jsxs("div", { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "Renach:" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: dados === null || dados === void 0 ? void 0 : dados.numeroRenach }))] }), _jsxs("div", { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "Data da Emiss\u00E3o:" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: dados === null || dados === void 0 ? void 0 : dados.dataEmissao }))] }), _jsxs("div", { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "UF Emiss\u00E3o:" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: dados === null || dados === void 0 ? void 0 : dados.ufEmissao }))] })] })), _jsxs("div", { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "Ciretran do Processo:" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: dados === null || dados === void 0 ? void 0 : dados.ultimaCiretranProcesso }))] })] })), debitos && (debitos === null || debitos === void 0 ? void 0 : debitos.length) > 1 && (_jsx(ContainerForm, __assign({ title: "" }, { children: _jsx(EmitirTodosBoletos, { debts: debitos }) })))] }) })), !consultaVazia ? (_jsx(Box, { children: _jsxs(ContainerLayout, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", justifyContent: "space-between" }, { children: [_jsx(Typography, __assign({ variant: "h5", fontSize: "1.375rem", fontWeight: "500", my: "1rem" }, { children: "D\u00E9bitos em Aberto" })), (selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.length) > 0 && (_jsx(Button, __assign({ variant: "contained", onClick: function () { return setModalDebts(true); } }, { children: "Emitir Selecionados" })))] })), _jsx(Divider, { sx: { mb: "1rem" } }), debitos === null || debitos === void 0 ? void 0 : debitos.map(function (debito) { return (_jsx(CardTaxaCondutor, { debito: debito, onChangeCheckbox: function (id) { return handleChangeId(id); } }, debito.idDebito)); })] }) })) : (_jsx(Box, __assign({ mt: "12rem" }, { children: _jsx(NaoEncontrado, { subtitulo: "O sistema n\u00E3o localizou nenhum d\u00E9bito para o condutor selecionado." }) }))), _jsx(Modal, __assign({ open: modalDebts, onClose: function () { return setModalDebts(false); }, icon: _jsx(Stack, __assign({ bgcolor: Colors.AZUL_GOV, borderRadius: "50%", p: "0.5rem" }, { children: _jsx(ChecklistOutlinedIcon, { sx: { color: "white" } }) })), title: "Emitir todos os d\u00E9bitos?", directionButtons: "row-reverse", buttons: [
                    _jsx(FormButton, { onClick: fetchSelectedDebts, title: "Confirmar", type: FormButtonType.PRIMARY, isLoading: loadingDebitos, isDisabled: loadingDebitos }, 0),
                    _jsx(FormButton, { onClick: function () { return setModalDebts(false); }, title: "Cancelar", type: FormButtonType.SECONDARY, isDisabled: loadingDebitos }, 1),
                ] }, { children: selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.map(function (id) {
                    var _a, _b, _c;
                    return (_jsxs(Typography, __assign({ variant: "body1", color: "textSecondary" }, { children: ["- ", (_a = getSelectedDebtInfo(id)) === null || _a === void 0 ? void 0 : _a.descricaoReduzida, " ", (_b = getSelectedDebtInfo(id)) === null || _b === void 0 ? void 0 : _b.exercicio, " - R$", " ", parseFloat(getSelectedDebtInfo(id).valorVencimento).toFixed(2)] }), (_c = getSelectedDebtInfo(id)) === null || _c === void 0 ? void 0 : _c.idDebito));
                }) })), base64 && (_jsx(ViewPdf, { isOpen: !!base64, close: function () { return setBase64(undefined); }, base64: base64, title: "D\u00E9bitos do Ve\u00EDculo" })), erro && (_jsx(SnackbarFeedback, { isOpen: !!erro, message: erro, type: "error" }))] }));
};
